export default __webpack_public_path__ + "static/media/stars.29c3f053.svg";